export { default } from './NewInfoBlock';



// WEBPACK FOOTER //
// ./src/components/molecules/NewInfoBlock/index.js